import styled from "@emotion/styled";
import { color } from "styles/color";

export const DailyDetail = styled.div`
  .functionBox {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    .ant-checkbox-wrapper {
      margin-right: 1rem;
    }
    .ant-checkbox-inner {
      border-color: ${color.markedSecondary};
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${color.markedSecondary};
    }
  }
  .searchBox {
    width: 100%;
    display: flex;
    margin-bottom: 1rem;
    flex-flow: row wrap;
    align-items: center;
    @media print {
      display: none;
    }
    @media (min-width: 768px) {
      div:first-of-type {
        margin-left: auto;
      }
    }
    .ant-checkbox-wrapper {
      margin-top: 1rem;
      order: 4;
      @media (min-width: 768px) {
        margin-top: 0;
        order: 1;
      }
    }
  }
  .inputBox {
    width: 100%;
    order: 3;
    margin-top: 1rem;
    display: flex;
    flex-flow: row wrap;
    gap: 1rem;
    @media (min-width: 768px) {
      order: 1;
      width: auto;
      margin-top: 0rem;
    }
    .input {
      width: calc(50% - 0.5rem);
      border-radius: 0.3rem;
      padding: 0.2rem 0.5rem;
      border: 1px solid ${color.default};
      outline: none;
      &:first-of-type {
        margin-right: 0rem;
      }
      &:disabled {
        background-color: ${color.secondary};
        border-color: ${color.borderGray};
      }
      @media (min-width: 768px) {
        width: fit-content;
        max-width: 120px;
      }
      @media (min-width: 900px) {
        max-width: 200px;
      }
    }
  }
  .dateOutter {
    display: flex;
    order: 2;
    width: 100%;
    margin-top: 1rem;
    @media (min-width: 768px) {
      order: 0;
      max-width: 200px;
      margin-top: 0;
      margin-right: 1rem;
    }
    .customInput {
      width: 100%;
      border: 1px solid ${color.default};
      padding: 0.2rem 0.5rem;
      border-radius: 0.3rem;
      text-align: left;
    }
    .react-datepicker__input-container input:not([type="range"]) {
      width: 100%;
      border-radius: 0.3rem;
      padding: 0.2rem 0.3rem;
      color: ${color.default};
      &:focus-visible {
        outline: none;
      }
    }
    .react-datepicker__close-icon {
      &:after {
        background-color: ${color.markedSecondary};
        position: absolute;
        right: 0.5rem;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
    .react-datepicker-popper[data-placement^="bottom"] {
      z-index: 10;
    }
    .react-datepicker {
      font-size: 1.125em;
      border-radius: 0.5rem;
      border-color: transparent;
      box-shadow: 4px 14px 10px 8px ${color.borderGray};
    }
    .react-datepicker__header {
      background-color: white;
    }
    .react-datepicker__navigation {
      top: 0.5rem;
    }
    .react-datepicker__navigation--previous {
      border-right-color: #ccc;
      left: 1em;
    }
    .react-datepicker__navigation--next {
      border-left-color: #ccc;
      right: 1em;
    }
    .react-datepicker__day--selected,
    .react-datepicker__day--in-selecting-range,
    .react-datepicker__day--in-range,
    .react-datepicker__day--keyboard-selected {
      background-color: ${color.markedSecondary};
    }
    .react-datepicker__today-button {
      color: white;
      background: ${color.markedSecondary};
      border: none;
      padding: 0.5rem 0;
      border-bottom-left-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
    .react-datepicker__month {
      margin: 0.7rem;
    }
    .react-datepicker__day-name,
    .react-datepicker__day,
    .react-datepicker__time-name {
      width: 2rem;
      line-height: 2rem;
    }
  }
  .dateDisabled.dateOutter {
    .customInput {
      border: 1px solid ${color.borderGray};
      background-color: ${color.secondary};
    }
  }
  .btnGroup {
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    @media (min-width: 768px) {
      align-items: center;
      width: auto;
      flex-flow: row nowrap;
    }
    .ant-checkbox-wrapper {
      margin-bottom: 1rem;
      @media (min-width: 768px) {
        margin-bottom: 0rem;
      }
    }
    button {
      color: white;
      padding: 0.2rem 0.5rem;
      border: 1px solid ${color.markedSecondary};
      background-color: ${color.markedSecondary};
      border-radius: 0.3rem;
      transition: all 0.3s;
      cursor: pointer;
      width: 100%;
      &:last-of-type {
        margin-top: 1rem;
        background-color: white;
        color: ${color.markedSecondary};
        @media (min-width: 768px) {
          margin-top: 0;
        }
      }
      &:disabled {
        background-color: ${color.secondary};
        border: 1px solid ${color.secondary};
        color: ${color.default};
      }
      @media (min-width: 768px) {
        width: inherit;
        margin-right: 1rem;
      }
    }
  }
  .ant-table-pagination.ant-pagination {
    align-items: center;
    margin-bottom: 1rem;
    line-height: inherit;
    &:first-of-type {
      margin-top: 0;
    }
  }
  .ant-pagination-total-text {
    display: flex;
    height: 100% !important;
    align-items: center;
    flex-flow: row nowrap;
    margin-right: auto;
    align-items: flex-end;
    button {
      color: white;
      padding: 0.2rem 0.5rem;
      border: 1px solid ${color.markedSecondary};
      background-color: ${color.markedSecondary};
      border-radius: 0.3rem;
      transition: all 0.3s;
      cursor: pointer;
      text-align: center;
      margin-right: 1rem;
    }
  }
  th.ant-table-cell {
    background-color: ${color.primaryBlue} !important;
    color: white;
    border-bottom: none;
    &:first-of-type {
      border-top-left-radius: 0.5rem !important;
    }
    &:last-of-type {
      border-top-right-radius: 0.5rem !important;
      border-right: 0px solid ${color.primaryBlue};
    }
  }
  td.ant-table-cell {
    border-bottom: 1px solid ${color.primaryBlue};
    border-right: 1px solid ${color.primaryBlue} !important;
    &:first-of-type {
      border-left: 1px solid ${color.primaryBlue};
    }
  }
  .ant-table-row {
    &:nth-of-type(odd) {
      //3n+4
      background-color: ${color.secondary};
    }
    &:nth-of-type(even) {
      //3n+4
      background-color: white;
    }
    @media print {
      page-break-inside: avoid;
    }
  }
  .ant-table-container {
    border: 0 !important;
  }
  .ant-table-sticky-scroll-bar {
    position: absolute;
    bottom: 30%;
    height: 10px;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: #ffe0a3;
  }
  .hidden {
    display: none;
  }
`;
export const Box = styled.div`
  order: 1;
  width: 100%;
  @media (min-width: 768px) {
    order: 2;
    width: auto;
  }
  @media print {
    display: none;
  }
  .ant-dropdown-trigger {
    border: 1px solid ${color.markedSecondary};
    border-radius: 0.2rem;
    padding: 0.2rem 0.5rem;
    color: ${color.markedSecondary};
    cursor: pointer;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (min-width: 768px) {
      max-width: 120px;
    }
  }
`;
export const ResultWrapper = styled.div`
  padding: 1rem 5%;
  width: 100%;
  .resultInfo {
    display: flex;
    padding: 0;
    flex-flow: column nowrap;
    @media (min-width: 768px) {
      align-items: center;
      flex-flow: row nowrap;
    }
    p {
      font-size: 1rem;
      color: ${color.default};
      @media (min-width: 768px) {
        margin-right: 2rem;
        margin-bottom: 0rem;
      }
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
`;
